<template>
  <el-dialog
    :close-on-click-modal="false"
    title="物流详情"
    :visible.sync="visible"
    width="800px"
    class="expre-detail"
    :before-close="handleClose"
  >
    <el-row style="font-size:14px;" :gutter="24">
      <el-col :span="8"> 订单编号：{{ detail.appNo }} </el-col>
      <el-col :span="8"> 物流单号：{{ detail.trackingNumber }} </el-col>
    </el-row>
    <el-timeline v-if="expreList.length > 0" style="margin: 16px 0 0 0">
      <el-timeline-item
        placement="top"
        v-for="(activity, index) in expreList"
        :key="index"
        :timestamp="activity.expreTime"
      >
        {{ activity.expreInfo }}
      </el-timeline-item>
    </el-timeline>
    <div v-else style="margin: 16px 0 0 0; font-size: 14px">暂无状态</div>
    <div slot="footer">
      <el-button size="small" type="primary" @click="handleClose"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { editSale } from "@/api/order/all"

import { mapGetters } from "vuex"

import { getExpreProcess } from "@/api/order/all"

export default {
  name: "ExpreDetail",
  data() {
    return {
      expreList: [],
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    detail: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  watch: {
    async visible() {
      if (this.visible) {
        let result = await getExpreProcess({
          expreId: this.detail.expreId,
          appId: this.detail.appId,
        })
        this.expreList = result
      }
    },
  },
  methods: {
    handleClose() {
      this.expreList = []
      this.$emit("onClose")
    },
  },
}
</script>

<style scoped>
.remarkDialog {
  font-size: 12px;
}

.item {
  display: flex;
  flex-wrap: wrap;
}

.tip {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
}

.tip .store-info-icon {
  display: inline-block;
  padding: 0 0 0 5px;
  background: #129ba7;
  color: #fff;
  border-radius: 2px;
  margin-right: 5px;
  line-height: 1.4;
}

.blue {
  color: #129ba7;
}
.expre-detail ::v-deep .el-dialog__body {
  height: 60vh;
  overflow-y: auto;
}
</style>
